import { usePlaidLink as defaultUsePlaidLink } from 'react-plaid-link'
import PropTypes from 'prop-types'

export default function usePlaidLink({ onSuccess, linkCustomizationName, onExit, publicToken = null }) {
  const plaidConfig = {
    // TODO: add userEmailAddress for better ux?
    clientName: 'Sixpence',
    env: process.env.REACT_APP_PLAID_ENVIRONMENT,
    product: ['auth', 'transactions'],
    // TODO: Update to use link token instead of public key: https://plaid.com/docs/link/link-token-migration-guide/
    publicKey: process.env.REACT_APP_PLAID_PUBLIC_KEY,
    webhook: `${process.env.REACT_APP_API_URL}/webhooks/plaid`,
    token: publicToken,
    onSuccess,
    onExit,
    linkCustomizationName
  }

  return defaultUsePlaidLink(plaidConfig)
}

usePlaidLink.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  linkCustomizationName: PropTypes.string.isRequired,
  publicToken: PropTypes.string,
  onExit: PropTypes.func
}
